import { render, staticRenderFns } from "./breadcrumb-comp.vue?vue&type=template&id=7c964a0b&"
import script from "./breadcrumb-comp.vue?vue&type=script&lang=js&"
export * from "./breadcrumb-comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports